<div class="notification-card" matTooltip="{{ toolTip }}">
  <div
    class="notification-card-bg"
    [ngClass]="{
      'notification-card-bg-error': type == Types.ERROR,
      'notification-card-bg-info': type == Types.INFO,
      'notification-card-bg-default': type == Types.DEFAULT,
      'notification-card-bg-csc': type == Types.CSC,
      'notification-card-bg-outage': type == Types.OUTAGE,
      'notification-card-bg-warn': type == Types.WARN
    }"
  >
    <ng-container [ngSwitch]="type">
      <span *ngSwitchCase="'error'" class="fa fa-exclamation-circle icon icon-error"></span>
      <span *ngSwitchCase="'info'" class="fa fa-info-circle icon icon-info"></span>
      <span *ngSwitchCase="'default'" class="fa fa-exclamation-triangle icon icon-default"></span>
      <span *ngSwitchCase="'csc'" class="fa fa-exclamation-triangle icon icon-csc"></span>
      <span *ngSwitchCase="'warn'" class="fa fa-exclamation-circle icon"></span>
      <app-svg-icon *ngSwitchCase="'outage'" class="icon icon-outage" src="../../../../../assets/icons/icon_info.svg"></app-svg-icon>
    </ng-container>

    <div
      *ngIf="header"
      class="header-text"
      [innerHtml]="header"
      [ngClass]="{
        'header-text-error': type == Types.ERROR,
        'header-text-info': type == Types.INFO,
        'header-text-default': type == Types.DEFAULT,
        'header-text-csc': type == Types.CSC,
        'header-text-outage': type == Types.OUTAGE,
        'header-text-warn': type == Types.WARN
      }"
    ></div>

    <div
      *ngIf="description"
      class="description-text"
      [innerHtml]="description"
      [ngClass]="{
        'description-text-error': type == Types.ERROR,
        'description-text-info': type == Types.INFO,
        'description-text-default': type == Types.DEFAULT,
        'description-text-csc': type == Types.CSC,
        'description-text-outage': type == Types.OUTAGE,
        'description-text-warn': type == Types.WARN
      }"
    ></div>

    <span
      *ngIf="text"
      class="info-text"
      [innerHtml]="text"
      [ngClass]="{
        'info-text-error': type == Types.ERROR,
        'info-text-info': type == Types.INFO,
        'info-text-warn': type == Types.WARN
      }"
    >
    </span>

    <div
      *ngIf="link"
      class="info-link"
      (click)="linkClicked.emit()"
      [ngClass]="{
        'info-link-error': type == Types.ERROR,
        'info-link-info': type == Types.INFO
      }"
    >
      {{ link }}
    </div>
  </div>
</div>
